import { inject, Injectable } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import { Environment } from '@rma/dashboard/generic/util/environment';
import { HeapWindow } from './domain/heap-window.model';

@Injectable({
  providedIn: 'root',
})
export class HeapService {
  private readonly window = inject<HeapWindow>(WA_WINDOW);
  private readonly environment = inject(Environment);

  public initialiseHeap(heapAppId?: string): void {
    if (!heapAppId) {
      return;
    }

    const environmentData = {
      rma_locale: this.environment.locale,
      rma_country_code: this.environment.countryCode,
      rma_domain: this.window.location.hostname,
    };

    // https://developers.heap.io/docs/using-identify#when-and-where-to-call-identify-and-adduserproperties
    this.addUserProperties(environmentData);
  }

  public addUserProperties(properties: Record<string, unknown>) {
    // https://developers.heap.io/docs/using-identify#when-and-where-to-call-identify-and-adduserproperties
    this.window.heap?.addUserProperties(properties);
  }

  public resetIdentity(): void {
    this.window.heap?.resetIdentity();
  }

  // eslint-disable-next-line no-restricted-syntax -- forwarded verbatim to heap.identify, which takes either form of identifier
  public identify(id: unknown): void {
    this.window.heap?.identify(id);
  }

  public addEventProperties(properties: Record<string, unknown>) {
    this.window.heap?.addEventProperties(properties);
  }
}
